import { CSSProperties } from 'react';

export const BUY_ONE_GET_MANY_CONTAINER_STYLE: CSSProperties = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  overflow: 'hidden'
};

export const BUY_ONE_GET_MANY_PREVIEW_INDEX_TO_COLLECT = 0;
